module.exports = __webpack_public_path__ + "img/gb9113_7.prt.449f027a.jpg";